// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"7811dbfa","458":"4fc2fdf6","682":"a4e89d90"}[chunkId] + ".chunk.css";
};